import { render, staticRenderFns } from "./setting_prezzi_trasporto.vue?vue&type=template&id=f05ce0bc&scoped=true&"
import script from "./setting_prezzi_trasporto.vue?vue&type=script&lang=js&"
export * from "./setting_prezzi_trasporto.vue?vue&type=script&lang=js&"
import style0 from "./setting_prezzi_trasporto.vue?vue&type=style&index=0&id=f05ce0bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05ce0bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VIcon,VProgressCircular,VRow,VTextField})
